let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9Veo5")).then(() => parcelRequire('kx7O4'));